import { useState } from "react";
interface UseDeleteDialogOptions<T> {
    onDelete: (item: T) => Promise<void>;
}

export const useDeleteDialog = <T,>({ onDelete }: UseDeleteDialogOptions<T>) => {
    const [open, setOpen] = useState(false);
    const [loadingDelete, setLoadingDelete] = useState(false);
    const [itemToDelete, setItemToDelete] = useState<T | null>(null);

    const openDialog = (item: T) => {
        setItemToDelete(item);
        setOpen(true);
    };

    const closeDialog = () => {
        if (loadingDelete) return;
        setOpen(false);
        setItemToDelete(null);
    }

    const confirmDelete = async () => {
        if (!itemToDelete) return;
        try {
            setLoadingDelete(true);
            await onDelete(itemToDelete);
            closeDialog();
        } catch (error) {
            console.log('Delete failed', error);
            throw error;
        } finally {
            setLoadingDelete(false)
        }
    };

    return {
        open,
        loadingDelete,
        itemToDelete,
        openDialog,
        closeDialog,
        confirmDelete
    }
}